import voll1 from "../images/urlag-sport/sport/volley/2020-1.jpg";
import voll2 from "../images/urlag-sport/sport/volley/2020-2.jpg";
import bask1 from "../images/urlag-sport/sport/basket/2022-1.jpg";
import bask2 from "../images/urlag-sport/sport/basket/2022-2.jpg";
import voll3 from "../images/urlag-sport/sport/volley/2022-1.jpg";
import voll4 from "../images/urlag-sport/sport/volley/2022-2.jpg";
import bask3 from "../images/urlag-sport/sport/basket/2023-1.jpg";
import bask4 from "../images/urlag-sport/sport/basket/2023-2.jpg";
import foot1 from "../images/urlag-sport/sport/foot/2023-1.jpg";
import foot2 from "../images/urlag-sport/sport/foot/2023-2.jpg";
import voll5 from "../images/urlag-sport/sport/volley/2024-1.jpg";
import voll6 from "../images/urlag-sport/sport/volley/2024-2.jpg";
import voll7 from "../images/urlag-sport/sport/volley/2024-3.jpg";
import naadam1 from "../images/urlag-sport/naadam/naadam-1.jpg";
import naadam2 from "../images//urlag-sport/naadam/naadam-2.jpg";
import marapon1 from "../images/urlag-sport/mara/marapon-1.jpg";
import marapon2 from "../images/urlag-sport/mara/marapon-2.jpg";
import foot3 from "../images/urlag-sport/sport/foot/2024-1.jpg";
import foot4 from "../images/urlag-sport/sport/foot/2024-2.jpg";
import foot5 from "../images/urlag-sport/sport/foot/2024-3.jpg";
import urlag1 from "../images/urlag-sport/u-naadam/urlag-1.jpg";
import urlag2 from "../images/urlag-sport/u-naadam/urlag-2.jpg";
import voll8 from "../images/urlag-sport/sport/volley/2025-1.jpg";
import voll9 from "../images/urlag-sport/sport/volley/2025-2.jpg";
import naadam3 from "../images/urlag-sport/naadam/naadam-3.jpg";
import naadam4 from "../images//urlag-sport/naadam/naadam-4.jpg";
import foot6 from "../images/urlag-sport/sport/foot/2025-1.jpg";
import foot7 from "../images/urlag-sport/sport/foot/2025-2.jpg";
import bask7 from "../images/urlag-sport/sport/basket/2025-1.jpg";
import bask8 from "../images/urlag-sport/sport/basket/2025-2.jpg";
import shinejil1 from "../images/urlag-sport/shine-jil/1.JPG";
import shinejil2 from "../images/urlag-sport/shine-jil/2.JPG";
import shinejil3 from "../images/urlag-sport/shine-jil/3.JPG";
import voll10 from "../images/urlag-sport/sport/volley/2026-1.jpg";
import voll11 from "../images/urlag-sport/sport/volley/2026-2.jpg";
import voll12 from "../images/urlag-sport/sport/volley/2026-3.jpg";
import naadam5 from "../images//urlag-sport/naadam/2026/1.jpg";
import naadam6 from "../images//urlag-sport/naadam/2026/2.jpg";
import naadam7 from "../images//urlag-sport/naadam/2026/3.jpg";
import naadam8 from "../images//urlag-sport/naadam/2026/4.jpg";
import foot8 from "../images/urlag-sport/sport/foot/2026-1.jpg";
import foot9 from "../images/urlag-sport/sport/foot/2026-2.jpg";
import foot10 from "../images/urlag-sport/sport/foot/2026-3.jpg";
import foot11 from "../images/urlag-sport/sport/foot/2026-4.jpg";


const UrlagSport = [
  {
    Id: "2",
    eImg: voll1,
    eImg2: voll2,
    title: "Анхдугаар волейболын тэмцээн",
    slug: "Шатар, ширээний теннисний тэмцээн мөн адил зохиогдсон байна",
    time: "2020-01-19",
  },
  {
    Id: "3",
    eImg: bask1,
    eImg2: bask2,
    title: "Анхдугаар сагсанбөмбөгийн тэмцээн",
    slug: "Нийт бүлэг, итгэгчдийнхээ дунд 2 дахь удаагийн тэмцээнээ амжилттай зохион байгуулсан",
    time: "2022-05-06",
  },
  {
    Id: "4",
    eImg: voll3,
    eImg2: voll4,
    title: "2 дахь удаагийн волейболын тэмцээн",

    time: "2022-12-25",
  },
  {
    Id: "5",
    eImg: bask3,
    eImg2: bask4,
    title: "2 дахь удаагийн сагсанбөмбөгийн тэмцээн",

    time: "2023-04-23",
  },
  {
    Id: "6",
    eImg: foot1,
    eImg2: foot2,
    title: "Анхдугаар хөлбөмбөгийн тэмцээн",

    time: "2023-09-03",
  },
  {
    Id: "7",
    eImg: marapon1,
    eImg2: marapon2,
    title: "Залуучуудын марафон",
    slug: "Урам зоригийн замаар",
    time: "2023-10-07",
    description:
      "Эрүүл мэнд, эв нэгдлийг дэмжсэн энэхүү марафонд олон зуун залуучууд идэвхитэй оролцож, зорилгын төлөө хамтдаа урагшилсан нь нийгмийн эрч хүч, эрүүл амьдралын хэв маягийг сурталчлахад чухал хувь нэмэр орууллаа.",
  },
  {
    Id: "8",
    eImg: urlag1,
    eImg2: urlag2,
    title: "Урлагийн их наадам",
    slug: "Авъяас ба итгэлээр гэрэлтсэн наадам",
    time: "2023-12-24",
    description:
      "Наадамд оролцогчид бүжиг, хөгжим, дуу, шүлэг, өгүүллэг, тайзны уран бүтээл, зэрэг төрөл бүрийн үзүүлбэрээр оролцож, авъяас чадвараа хөгжүүлэхээс гадна сэтгэлээрээ нэгдэн, урам зориг, итгэл найдварын мессежийг олон нийтэд хүргэдэг. Энэхүү арга хэмжээ нь зөвхөн урлагын уралдаан бус, харин амьдралын үнэ цэн, итгэл найдвар, хайр энэрлийг урлагаар дамжуулан түгээн дэлгэрүүлдэг сэтгэлд хоногших үйл явдал юм.",
  },
  {
    Id: "9",
    eImg: voll5,
    eImg2: voll6,
    eImg3: voll7,
    title: "3 дахь удаагийн волейболын тэмцээн",

    time: "2024-05-05",
  },
  {
    Id: "10",
    eImg: naadam1,
    eImg2: naadam2,
    title: "Монгол наадам-2024",
    slug: "Соёлын өвийг гэрэлтэйгээр илтгэх мөч",
    time: "2024-07-07",
    description:
      "Монгол Сувд Сүмийн Наадмын үеэр оролцогчид урлагын үзүүлбэр толилуулж, уламжлал, урлагийн нэгдлийг илтгэх энэхүү наадам нь олон нийтийг нэгэн зорилго, нэгэн сэтгэл дор цуглуулж, соёлын үнэ цэнийг гүн гүнзгий мэдрүүлдэг билээ.",
  },
  {
    Id: "11",
    eImg: foot3,
    eImg2: foot4,
    eImg3: foot5,
    title: "2 дахь удаагийн хөлбөмбөгийн тэмцээн",

    time: "2024-10-06",
  },
  {
    Id: "13",
    eImg: voll8,
    eImg2: voll9,
    title: "4 дэх удаагийн волейболын тэмцээн",
    time: "2025-04-20",
  },
  {
    Id: "14",
    eImg: naadam3,
    eImg2: naadam4,
    title: "Эв эе, өв соёл, эрхэм жаргалтай наадам-2025",
    slug: "Соёлын өвийг гэрэлтэйгээр илтгэх мөч-2",
    time: "2025-07-06",
    description:
      "Монгол Сувд Сүмийн Наадмын үйл ажиллагааг 2 дахь удаагаа амжилттай зохион байгууллаа",
  },
  {
    Id: "15",
    eImg: foot6,
    eImg2: foot7,
    title: "3 дахь удаагийн хөлбөмбөгийн тэмцээн",
    time: "2025-09-28",
  },
  {
    Id: "16",
    eImg: bask7,
    eImg2: bask8,
    title: "4 дэх удаагийн сагсанбөмбөгийн тэмцээн",

    time: "2025-11-23",
  },
  {
    Id: "17",
    eImg: shinejil1,
    eImg2: shinejil2,
    eImg3: shinejil3,
    title: "Шинэ жилийн баярын нэгдсэн үйл ажиллагаа-2025",
    time: "2025-12-24",
  },
  {
    Id: "18",
    eImg: voll10,
    eImg2: voll11,
    eImg3: voll12,
    title: "5 дэх удаагийн волейболын тэмцээн",
    time: "2026-03-29",
  },
  {
    Id: "19",
    eImg: naadam7,
    eImg2: naadam6,
    title: "Эв эе, өв соёл, эрхэм жаргалтай наадам-2026",
    slug: "Соёлын өвийг гэрэлтэйгээр илтгэх мөч-3",
    time: "2026-07-05",
    description:
      "Монгол Сувд Сүмийн Наадмын үйл ажиллагааг 3 дахь удаагаа амжилттай зохион байгууллаа",
  },
  {
    Id: "",
    eImg: foot8,
    eImg2: foot9,
    eImg3: foot10,
    title: "4 дэх удаагийн хөлбөмбөгийн тэмцээн",
    // slug: "Соёлын өвийг гэрэлтэйгээр илтгэх мөч-3",
    time: "2026-09-27",
    
  },
];

export default UrlagSport;
